import React from 'react';
import { Topbar } from './light/Topbar';
import { Graph } from '../generated/graph';
import { ResponsiveMenu } from './light/MainMenu';
import { ProfileSideMenu } from './light/ProfileSideMenu';
import menuItems from '../menu-items';

type Props = {
  user: Graph.User
}

class MasterLayout extends React.Component<Props> {
  render() {
    return this.renderLayout();
  }

  renderLayout = () => {
    let uploadSotrage = Number(this.props.user.uploadStorage);
    let storageMeasure = "MB";
    //Convert to GB if storage more than 1024Mb
    if(uploadSotrage >= 1024) {
      uploadSotrage = (uploadSotrage / 1024);
      storageMeasure = "GB";
    }

    return (
      <div className='all-wrapper solid-bg-all'>
        <Topbar title={ (window as any).setting.title }/>

        <div className='layout-w min-full-height'>
          <ResponsiveMenu items={menuItems}>
            <ProfileSideMenu
              name={ this.props.user!.name!.en! }
              role={ this.props.user!.role! }
              profilePicture={ this.props.user!.profilePicture! }
              uploadStorage={ uploadSotrage.toFixed(4) + storageMeasure }
            />
          </ResponsiveMenu>

          { this.props.children }
        </div>
      </div>
    )
  }
}

export function AdminLayout(props: React.PropsWithChildren<Props>) {
  return (
    <MasterLayout user={props.user}>{props.children}</MasterLayout>
  );
}